import { ADMIN_PREVIEW_KEYWORD } from '../../constants';

export const formPreviewPath = (baseURL: string, mode?: string) => {
  let returnPath = `${baseURL}#${ADMIN_PREVIEW_KEYWORD}`;
  if (mode && mode !== 'undefined') {
    returnPath += `-${mode}`;
  }
  return returnPath;
};
